import React, { useState } from 'react';
import { GeneralModal } from 'ui/GeneralModal';
import { ModalHeading } from 'ui/GeneralModal/ModalHeading';
import FluidButton from 'ui/FluidButton';
import { useFilesInput } from 'hooks/useFilesInput';
import { ConfirmationModal, EConfirmationModalType } from 'ui/ConfirmationModal';

interface IUploadInvoiceModalProps {
  onClose: () => void;
  onFileSelected: (file: File) => void;
}

export const UploadInvoiceModal = ({ onClose, onFileSelected }: IUploadInvoiceModalProps) => {
  const [showDiscardConfirmation, setShowDiscardConfirmation] = useState(false);
  const { files, renderInput, reset } = useFilesInput({ multiple: false });

  const selectedFile = files[0] ?? null;

  const handleSelectFile = () => {
    if (selectedFile) {
      onFileSelected(selectedFile);
      reset();
    }
  };

  const handleCloseAttempt = () => {
    if (selectedFile) {
      setShowDiscardConfirmation(true);
    } else {
      onClose();
    }
  };

  const handleConfirmDiscard = () => {
    setShowDiscardConfirmation(false);
    reset();
    onClose();
  };

  const handleCancelDiscard = () => {
    setShowDiscardConfirmation(false);
  };

  return (
    <>
      <GeneralModal
        onClose={handleCloseAttempt}
        modalWindowClassName="w-[600px] px-[35px] py-[25px] rounded"
        shouldCloseByClickingOutside={false}
      >
        <ModalHeading>Upload Invoice</ModalHeading>

        <div className="mt-[20px]">
          <span className="font-pt-sans font-bold text-[16px] text-black block mb-[8px]">File *</span>
          {renderInput()}
        </div>

        <div className="flex items-center justify-between mt-[25px]">
          <FluidButton type="secondary" onClick={handleCloseAttempt}>
            Cancel
          </FluidButton>
          <FluidButton type="primary" onClick={handleSelectFile} disabled={!selectedFile}>
            Select Invoice File
          </FluidButton>
        </div>
      </GeneralModal>

      {showDiscardConfirmation && (
        <ConfirmationModal
          className="leave-without-saving z-30"
          type={EConfirmationModalType.WARNING}
          title="You have made changes to this page, and not saved..."
          message="Are you sure you want to leave this page?"
          confirmButtonLabel="Leave"
          cancelButtonLabel="Cancel"
          onConfirm={handleConfirmDiscard}
          onCancel={handleCancelDiscard}
        />
      )}
    </>
  );
};
